import React, {useRef, useState} from "react";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import axios from "axios";
import qs from "qs";
import {Toast} from "primereact/toast";
import {Message} from "primereact/message";

export const PayFastCheckout = ({amount, cancelTopup, currency, allowCheckout}) => {
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const userAuth = useSelector(state => state.userAuth);
    const mopriSettings = useSelector(state => state.mopriSettings);
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);
    const myToast = useRef(null);

    const handlePayFastPayment = async () => {
        setSubmitButtonDisabled(true);
        try {
            const response = await axios({
                method: 'post',
                url: `${apiURL}/api/gateway/payFastPayment`,
                data: qs.stringify({
                    value: amount,
                    uid: userAuth.mopriUID,
                    email: userAuth.email,
                    firstName: userAuth.firstName,
                    lastName: userAuth.lastName,
                    currencyCode: mopriSettings.internationalSettings.localizationCountry,
                    baseURL: window.location.origin
                }),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            });

            if (response && response.data.error) {
                myToast.current.show({severity: 'error', summary: 'ERROR', detail: response.data.errorMessage, life: 5000});
            } else if (response && response.data.url && response.data.payload) {
                myToast.current.show({severity: 'success', summary: 'Redirecting', detail: 'You will be redirected to PayFast to complete the topup.', life: 3000});

                // Dynamically create and submit the form
                const form = document.createElement('form');
                form.action = response.data.url;
                form.method = 'POST';
                form.style.display = 'none';

                for (const key in response.data.payload) {
                    if (response.data.payload.hasOwnProperty(key)) {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = key;
                        input.value = response.data.payload[key];
                        form.appendChild(input);
                    }
                }

                document.body.appendChild(form);
                form.submit(); // Uncomment this line to trigger the redirect
                document.body.removeChild(form);
            } else {
                myToast.current.show({severity: 'warn', summary: 'Warning', detail: 'Invalid response received from the server.', life: 5000});
                setSubmitButtonDisabled(false);
            }
        } catch (e) {
            myToast.current.show({severity: 'error', summary: 'ERROR', detail: 'An unspecified error took place while attempting to do the PayFast checkout.', life: 5000});
            setSubmitButtonDisabled(false);
            console.error(e);
        }
    };

    return (
        <div className="grid" style={{paddingBottom: '20px'}}>
            <Toast ref={myToast}/>
            <div className="col-6">
                <div className="flex align-items-center">
                    <img
                        src="img/payfast-logo.png"
                        alt={"PayFast"}
                        style={{
                            height: '60px',
                            width: 'auto',
                        }}
                    />
                </div>
            </div>
            <div className="col-6" style={{paddingTop: '20px'}}>
                <div className="p-fluid grid">
                    <div className="field col-6">
                        {allowCheckout &&
                            <Button label="Cancel"
                                    severity="danger" type="button"
                                    disabled={submitButtonDisabled}
                                    onClick={() => cancelTopup()}
                            />
                        }
                    </div>
                    <div className="field col-6">
                        <Button label={`Checkout ${amount ? `(${currency}${amount})` : ''}`}
                                severity="success"
                                disabled={submitButtonDisabled || !allowCheckout}
                                onClick={handlePayFastPayment}
                        />
                    </div>
                </div>
            </div>

            {submitButtonDisabled &&
                <div className="col-12">
                    <Message severity="success" text="Please wait, you are about to be redirected to PayFast to complete the topup." className="w-full justify-content-start"/>
                </div>
            }
        </div>
    );
};